<div class="bg-benefits">
  <div class="section-wrapper">
    <section id="benefices" class="container-benefits">
      <h2>Bénéfices</h2>
      <div class="benefits-grid">
        <div class="card">
          <h3>
            <fa-icon [icon]="faSitemap" size="lg"></fa-icon>
            <span>Organisation centralisée</span>
          </h3>
          <p>La gestion centralisée des documents RH permet une meilleure organisation et une meilleure accessibilité aux informations.</p>
        </div>
        <div class="card">
          <h3>
            <fa-icon [icon]="faScaleBalanced" size="lg"></fa-icon>
            <span>Conformité aux réglementations</span>
          </h3>
          <p>
            Une solution de gestion de documents RH peut aider l'entreprise à rester conforme aux lois et réglementations en matière de RH,
            telles que les lois sur les congés payés et les données personnelles.
          </p>
        </div>
        <div class="card">
          <h3>
            <fa-icon [icon]="faMagnifyingGlassChart" size="lg"></fa-icon>
            <span>Analyse de données</span>
          </h3>
          <p>
            Les solutions de gestion de documents RH peuvent fournir des données et des analyses pour aider l'entreprise à prendre des
            décisions en matière de RH.
          </p>
        </div>
        <div class="card">
          <h3>
            <fa-icon [icon]="faComments" size="lg"></fa-icon>
            <span>Meilleure communication</span>
          </h3>
          <p>
            Une solution de gestion de documents RH peut faciliter la communication entre les salariés et la gestion en ce qui concerne les
            informations RH.
          </p>
        </div>
        <div class="card">
          <h3>
            <fa-icon [icon]="faTruckFast" size="lg"></fa-icon>
            <span>Accès rapide et facile</span>
          </h3>
          <p>
            Les salariés et les responsables peuvent accéder aux documents RH importants en un clic, ce qui améliore la productivité et la
            satisfaction des collaborateurs.
          </p>
        </div>
        <div class="card">
          <h3>
            <fa-icon [icon]="faRobot" size="lg"></fa-icon>
            <span>Automatisation des processus</span>
          </h3>
          <p>
            Certaines tâches telles que la mise à jour des informations, la génération de rapports, etc. peuvent être automatisées, ce qui
            économise du temps et de l'énergie.
          </p>
        </div>
      </div>
    </section>
  </div>
</div>
